import React, { useState, useEffect } from "react";

import ErrorBoundary from "components/ErrorBoundary";
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilter } from 'utils/helper';
import PurchaseTable from "./PurchaseTable";
import { cloneDeep } from "lodash";


let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: '',
  filters: [],
};

let thirdPartyAdminDetails = {};

let filtervalues = {}

const Purchase = ({ tenantID, rowData }) => {

  const API = useAxios();
    const [columnFilters, setColumnFilters] = useState([]);
  
  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: '',
    coveredId: '',
    records: 0,
    reset: false,
  });
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    };
     setColumnFilters(null) ;
    setState({ data: [], records: 0 });
    if (rowData) {
      const { ndc, contractID, opaCode, npi } = rowData;
      if (ndc) {
        initialFilters.filters = getUpdatedFilter(
          'DrugID',
          ndc,
          initialFilters
        );
      }
      initialFilters.currentPage = 1;
      fetchPurchaseData(initialFilters);
    }

  }, []);

  const fetchPurchaseData = async (pageDetails = {}, hasColumnFilter) => {
    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      //initialFilters.filters = [...filter.filters];
    } else {
      initialFilters = { ...initialFilters, ...filter };
    }
    setColumnFilters(filter);
    try {
      const { data } = await API.post(
        `/${tenantID}/Inventory/Purchase/${rowData.contractID}`, filter
      );
      if (data) {
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [], records: 0 });
    }
  };

  // const handleExport = () => {
  //   const { access_token } =
  //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Inventory/ExportPurchases/${rowData.contractID}?access_token=${access_token}`;
  //   onExport(action, initialFilters);
  // };
  const handleExport = async () => {
   let filterObj = columnFilters ? columnFilters : initialFilters;

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
additionalCriteria.ContractId = rowData.contractID

    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "ndcpurchaseaccumulation";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj );
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  
  };



  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      fetchPurchaseData(filter, true);
    } else {
      fetchPurchaseData(filter);
    }
  };

 const handleSearchColumnFilters = async (columnFilters) => {
    setColumnFilters({ ...initialFilters, ...columnFilters })
    await fetchPurchaseData({ ...initialFilters, ...columnFilters }, true);
  };

 const refetch = (hasReset) => {
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
      };
    }
    setColumnFilters(initialFilters)
    fetchPurchaseData(initialFilters);
  };


  return (
    <div>
      <ErrorBoundary>
        <PurchaseTable
          data={state.data}
          loading={state.loading}
          onExport={handleExport}
          filters={initialFilters}
          totalSize={state.records}
          onPageChange={onPageChange}
          setLoading={(value) => setState({ loading: value })}
          refetch={refetch}
          onSearchColumnFilters={handleSearchColumnFilters}
          reset={state.reset}
        />
      </ErrorBoundary>
    </div>
  );
};

export default Purchase;
